// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Success: MarkdocTagRegistration = {
  tag: 'success',
  component: 'Success',
};
